import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { AuthenticationService } from './authentication.service';
import { Gtp } from 'src/app/shared/gtp';
import { environment } from 'src/environments/environment';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor(
        //private authenticationService: AuthenticationService,
        private gtp: Gtp
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = JSON.parse(this.gtp.getItemLocalStorage('currentUser'));
        if (currentUser && currentUser.token) {
            request = request.clone({
                url: this.serverPath(request.url),
                setHeaders: {
                    // 'Content-Type': 'application/json', // Comentado para permitir FormData automáticamente
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${currentUser.token}`,
                    // "Access-Control-Allow-Origin": "*",
                    // "Access-Control-Allow-Headers": "origin, content-type, accept, authorization",
                    // "Access-Control-Allow-Credentials": "true",
                    // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
                    // "Access-Control-Max-Age": "1209600",
                }
            });

        }
        return next.handle(request);
    }
    /**
     * Cambia el path para que apunte a la base de datos correcta
     * @param url path del url sin modificación
     * @example https://gtpmovil.com/apirastreo/v1/listar/getvehiculos/349
     * @return https://gtpmovil.com/apiflota/v1/listar/getvehiculos/349
     */
    serverPath(url){
        let current = JSON.parse(this.gtp.getItemLocalStorage('currentUser'));
        let serverPath = current.serverPath;
        let newPath = url.replace(environment.path, serverPath);
        return newPath;
    }
}
